import { z } from 'zod';

export const heroSplitSchema = z.object({
  eyebrow: z.string().max(80).optional(),
  h1: z.string().min(1).max(200),
  highlight: z.string().max(60).optional(),
  sub: z.string().max(400).optional(),
  ctaPrimary: z.object({ label: z.string().max(60), href: z.string().max(500) }).optional(),
  ctaSecondary: z.object({ label: z.string().max(60), href: z.string().max(500) }).optional(),
  image: z.string().url().or(z.string().min(1)),
  imageAlt: z.string().max(160).default(''),
  reverse: z.boolean().default(false),
  theme: z.enum(['light', 'dark', 'lime']).default('light'),
});

export type HeroSplitData = z.infer<typeof heroSplitSchema>;
